import {unsubscribeReason} from './UnsubscribeReason/sl'
import {unsubscribePage} from './UnsubscribePage/sl'

export const unsubscribe = {
  ...unsubscribeReason,
  ...unsubscribePage,
}
